import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { appConfigService } from '@/services/rest';
import type { ConfigResponse } from '@/types/apps/config.type';

interface AppConfigState {
    configs: ConfigResponse[];
    loading?: boolean;
    error?: string;
}

type FetchReject = string;

export const fetchAppConfigs = createAsyncThunk<
    any,
    void,
    { rejectValue: FetchReject }
>('appConfig/fetch', async (_, { rejectWithValue }) => {
    try {
        const res = await appConfigService().index();

        if (!res.success) {
            return rejectWithValue('Failed to fetch app configs');
        }

        return res;
    } catch {
        return rejectWithValue('Failed to fetch app configs');
    }
});

const initialState: AppConfigState = {
    configs: [],
    loading: false,
    error: undefined,
};

export const appConfigSlice = createSlice({
    name: 'appConfig',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchAppConfigs.pending, state => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchAppConfigs.fulfilled, (state, { payload }) => {
                state.configs = payload.result.items;
                state.loading = false;
            })
            .addCase(fetchAppConfigs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Không thể tải config';
            });
    },
});

export default appConfigSlice.reducer;
